import { detailedTransactionsSelector } from 'scripts/redux/selectors/transactions';
import { userSelector } from 'scripts/redux/selectors/user';
import { fetchDetailedTransactions } from 'scripts/redux/actions/transactions';
import withFetching from 'src/decorators/withFetching';

const withDetailedTransactions = withFetching([detailedTransactionsSelector, userSelector], [fetchDetailedTransactions]);

export default withDetailedTransactions;
